import { useEffect } from 'react';

const RedirectToMainWebsitePage = () => {
  useEffect(() => {
    window.location.href = 'https://www.pushtrainingapp.com';
  }, []);

  return null;
};

export default RedirectToMainWebsitePage;
